// extracted by mini-css-extract-plugin
module.exports = {"wrap":"IO","heading":"JO"};